import { http } from '@talend/http';

import { HttpResponse, CustomAttributeDefinition, PaginatedData } from '../CAD.types';
import { addPaginatedParams, getCallPaginated } from './utils';

export async function getCustomAttributeDefinitionsPage(
	offset: number,
	limit: number,
): Promise<HttpResponse<PaginatedData<CustomAttributeDefinition>>> {
	return http.get(addPaginatedParams('/api/v1/attributes', offset, limit)) as Promise<
		HttpResponse<PaginatedData<CustomAttributeDefinition>>
	>;
}

export async function deleteCustomAttributeDefinition(id: string): Promise<any> {
	return http.delete(`/api/v1/attributes/${id}`) as Promise<any>;
}

export async function getCustomAttributeDefinition(id: string): Promise<any> {
	return http.get(`/api/v1/attributes/${id}`) as Promise<any>;
}

export async function getCustomAttributeDefinitions(): Promise<
	HttpResponse<PaginatedData<CustomAttributeDefinition>>
> {
	return getCallPaginated<PaginatedData<CustomAttributeDefinition>>(
		getCustomAttributeDefinitionsPage,
	);
}

export async function postCustomAttributesDefinition(body: object): Promise<any> {
	return http.post('/api/v1/attributes', body) as Promise<any>;
}

export async function patchCustomAttributesDefinition(
	definitionId: string,
	body: object,
): Promise<any> {
	return http.patch(`/api/v1/attributes/${definitionId}`, body) as Promise<any>;
}
